var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.date
    ? _c(
        "div",
        {
          staticClass:
            "d-flex flex-column justify-content-center align-items-center",
        },
        [
          _vm.$moment().format("jYY-jMM-jDD") !==
          _vm.$moment(_vm.date).format("jYY-jMM-jDD")
            ? _c("p", { staticClass: "text-primary" }, [
                _vm._v(
                  "\n    " +
                    _vm._s(_vm.$moment(_vm.date).format("jD jMMMM")) +
                    "\n  "
                ),
              ])
            : _c("p", { staticClass: "text-primary" }, [_vm._v("امروز")]),
          _c("p", { staticStyle: { color: "#9a9a9a", "font-size": ".9rem" } }, [
            _vm._v(_vm._s(_vm._f("time")(_vm.date))),
          ]),
        ]
      )
    : _c(
        "p",
        {
          staticClass: "mb-0",
          staticStyle: { color: "#9a9a9a", "font-size": ".9rem" },
        },
        [_vm._v("---")]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }